<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackgroundBlurStrong_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <g clip-path="url(#IconBackgroundBlurStrong_32__a)">
        <g clip-path="url(#IconBackgroundBlurStrong_32__b)">
            <circle cx="4.667" cy="5.667" r=".667" fill="currentColor" />
            <circle cx="9.833" cy="5.667" r="1.667" fill="currentColor" />
            <circle cx="16" cy="5.667" r="1.667" fill="currentColor" />
            <circle cx="22.167" cy="5.667" r="1.667" fill="currentColor" />
            <g filter="url(#IconBackgroundBlurStrong_32__c)">
                <circle cx="27.333" cy="5.667" r=".667" fill="currentColor" />
            </g>
            <circle cx="10.667" cy="21.333" r="1.333" fill="currentColor" />
            <path
                fill="currentColor"
                d="M16 16a3.2 3.2 0 0 1-2.354-.98 3.2 3.2 0 0 1-.98-2.353q0-1.376.98-2.354A3.2 3.2 0 0 1 16 9.333a3.2 3.2 0 0 1 2.354.98 3.2 3.2 0 0 1 .98 2.354 3.2 3.2 0 0 1-.98 2.354A3.2 3.2 0 0 1 16 16m-5 6.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 9.333 21v-.667q0-.708.365-1.302t.969-.906q1.29-.645 2.625-.97A11.5 11.5 0 0 1 16 16.834q1.376 0 2.708.323 1.334.323 2.625.969.604.312.969.906t.365 1.302V21q0 .687-.49 1.177t-1.177.49z"
            />
            <circle cx="4.667" cy="26.667" r=".667" fill="currentColor" />
            <circle cx="10" cy="26.667" r="1.333" fill="currentColor" />
            <circle cx="16" cy="26.667" r="1.333" fill="currentColor" />
            <circle cx="22" cy="26.667" r="1.333" fill="currentColor" />
            <circle cx="27.333" cy="26.667" r=".667" fill="currentColor" />
            <circle
                cx="26.333"
                cy="11"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 26.333 11)"
            />
            <circle
                cx="26.333"
                cy="16.333"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 26.333 16.333)"
            />
            <circle
                cx="5.667"
                cy="11"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 5.667 11)"
            />
            <circle
                cx="5.667"
                cy="16.333"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 5.667 16.333)"
            />
            <circle
                cx="26.333"
                cy="21.667"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 26.333 21.667)"
            />
            <circle
                cx="5.667"
                cy="21.667"
                r="1.667"
                fill="currentColor"
                transform="rotate(90 5.667 21.667)"
            />
        </g>
        <g filter="url(#IconBackgroundBlurStrong_32__d)">
            <circle cx="1" cy="16" r="1" fill="currentColor" />
        </g>
        <g filter="url(#IconBackgroundBlurStrong_32__e)">
            <circle cx="16" cy="1" r="1" fill="currentColor" />
        </g>
        <g filter="url(#IconBackgroundBlurStrong_32__f)">
            <circle cx="31" cy="16" r="1" fill="currentColor" />
        </g>
        <g filter="url(#IconBackgroundBlurStrong_32__g)">
            <circle cx="16" cy="31" r="1" fill="currentColor" />
        </g>
    </g>
    <defs>
        <filter
            id="IconBackgroundBlurStrong_32__c"
            width="12"
            height="12"
            x="21.333"
            y="5"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="5.333" />
            <feGaussianBlur stdDeviation="2.667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_314"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_314"
                result="shape"
            />
        </filter>
        <filter
            id="IconBackgroundBlurStrong_32__d"
            width="12.667"
            height="12.667"
            x="-5.333"
            y="15"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="5.333" />
            <feGaussianBlur stdDeviation="2.667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_314"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_314"
                result="shape"
            />
        </filter>
        <filter
            id="IconBackgroundBlurStrong_32__e"
            width="12.667"
            height="12.667"
            x="9.667"
            y="0"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="5.333" />
            <feGaussianBlur stdDeviation="2.667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_314"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_314"
                result="shape"
            />
        </filter>
        <filter
            id="IconBackgroundBlurStrong_32__f"
            width="12.667"
            height="12.667"
            x="24.667"
            y="15"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="5.333" />
            <feGaussianBlur stdDeviation="2.667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_314"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_314"
                result="shape"
            />
        </filter>
        <filter
            id="IconBackgroundBlurStrong_32__g"
            width="12.667"
            height="12.667"
            x="9.667"
            y="30"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="5.333" />
            <feGaussianBlur stdDeviation="2.667" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_314"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_314"
                result="shape"
            />
        </filter>
        <clipPath id="IconBackgroundBlurStrong_32__a">
            <path fill="currentColor" d="M0 0h32v32H0z" />
        </clipPath>
        <clipPath id="IconBackgroundBlurStrong_32__b">
            <path fill="currentColor" d="M4 4h24v24H4z" />
        </clipPath>
    </defs>
</svg>
